import React from 'react';
import './index.scss';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import SectionHeader from '../../../SectionHeader';

const RatersResponseTable = (props) => {
  const rows = props.fetchTotalFeedbackProvidersApi.data != null && props.fetchTotalFeedbackProvidersApi.data.data ? props.fetchTotalFeedbackProvidersApi.data.data : [];
  // Last row is the total/stakeholders summary; the rest are the rater groups.
  const groups = rows.slice(0, -1);
  const totalRow = rows.length ? rows[rows.length - 1] : null;

  const formatValue = (value) => Number(value || 0).toLocaleString();
  const formatLabel = (type) => (type ? type.charAt(0).toUpperCase() + type.slice(1) : '');
  return (
    <AsyncSection api={props.fetchTotalFeedbackProvidersApi} loaderHeight={200} loaderWidth={800}>
      <SectionHeader
        eyebrow='Context'
        title='Who gave feedback, and how'
        description='Composition of stakeholder groups and how many left qualitative comments alongside their ratings.'
      />



    <div className='cardwrapper'>
      <h3>Who gave feedback</h3>
      <p className='description-container'>Raters by group. Self is one per participant; stakeholder counts are per participant rated, so one person rating two leaders counts twice.</p>
          <div className="raters-cards">
            {groups.map((col) => {

              return (
                <div className="raters-card" key={col.key}>
                  <p className="raters-card__label">{formatLabel(col.type)}</p>
                  <p className="raters-card__value">{formatValue(col.value)}</p>
                  <p className="raters-card__meta">{Math.trunc(col.percent)}% of total</p>
                </div>
              );
            })}
            {totalRow && (
              <div className="raters-card raters-card--total" key={totalRow.key}>
                <p className="raters-card__label">STAKEHOLDERS</p>
                <p className="raters-card__value">{formatValue(totalRow.value)}</p>
                <p className="raters-card__meta">excluding self</p>
              </div>
            )}
          </div>

    </div>
    </AsyncSection>
  );
};

export default RatersResponseTable;
